<template>
  <section v-if="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>Rol y Notificaciones</h4>
      <p>Define para qué procesos será utilizado este contacto.</p>
    </header>

    <div class="app-modal__toggles">
      <label class="app-modal-toggle">
        <input v-model="form.invoice_mailing" type="checkbox" />
        <span>Cotización / Facturación</span>
      </label>

      <label class="app-modal-toggle">
        <input v-model="form.payments_mailing" type="checkbox" />
        <span>Complementos de pago</span>
      </label>

      <label class="app-modal-toggle">
        <input v-model="form.is_debt_contact" type="checkbox" />
        <span>Contacto de cobranza</span>
      </label>

      <label class="app-modal-toggle app-modal-toggle--primary">
        <input v-model="form.default" type="checkbox" />
        <span>Contacto principal</span>
      </label>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PersonSectionRole',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
};
</script>
